<template>
  <div class="info-box">
    <el-form
      :model="state.model"
      label-width="auto"
      label-position="top"
      ref="formDom"
      size="large"
      class="flex-1 overflow-y-auto px-2.5"
    >
      <el-form-item
        label="酒店"
        prop="hotel_id"
        :rules="[{ required: true, message: '请选择酒店', trigger: 'blur' }]"
      >
        <div class="flex w-full">
          <el-select
            v-model="state.model.hotel_id"
            filterable
            placeholder="--请选择--"
            fit-input-width
            @change="onLoadRoom()"
          >
            <template #label="{ value }">
              <div
                v-if="hotel_map.get(value)"
                class="grid !w-full gap-x-5"
                style="grid-template-columns: 1fr auto"
              >
                <text>{{ hotel_map.get(value).name }}</text>
                <text class="text-gray-400">{{
                  hotel_map.get(value).address
                }}</text>
              </div>
            </template>
            <el-option
              v-for="item in state.hotel_data"
              :key="item.id"
              :label="`${item.name} ${item.address}`"
              :value="item.id"
              style="height: auto"
            >
              <div class="grid grid-cols-[1fr_auto]">
                <text>{{ item.name }}</text>
                <text class="text-gray-400">{{
                  item.d_hotel_rating_name
                }}</text>
              </div>
              <ul
                class="text-gray-400 break-all break-words whitespace-normal"
                style="margin-top: -5px; line-height: 20px"
              >
                {{
                  item.address
                }}
              </ul>
            </el-option>
            <template #footer>
              <el-button
                plain
                class="float-right mb-3"
                size="small"
                @click="onLoadHotel()"
              >
                刷新
              </el-button>
            </template>
          </el-select>
          <el-button
            type="primary"
            icon="plus"
            link
            @click="state.showJiuDianAdd = true"
            >添加
          </el-button>
        </div>
      </el-form-item>
      <el-form-item
        label="房型需求"
        prop="add_data"
        :rules="[
          { required: true, message: '请填写房型需求', trigger: 'blur' },
        ]"
      >
        <div
          class="grid grid-cols-[1fr_auto] gap-x-3 items-center w-full mb-2"
          v-for="(fx, index) in state.model.add_data"
          :key="fx"
        >
          <!-- <div
            @click="state.model.add_data.splice(index, 1)"
            class="absolute right-0 top-0 cursor-pointer hover:!opacity-60"
            style="right: -8px; top: -13px"
          >
            <el-icon color="#f00" :size="20"><CircleClose /></el-icon>
          </div> -->
          <div class="bg-gray-100 rounded-lg p-2.5">
            <ul
              class="grid grid-cols-[240px_1fr_200px] w-full items-center pb-2"
            >
              <el-form-item
                label="入住日期："
                size="default"
                :prop="'add_data.' + index + '.checkin_date'"
                label-width="auto"
                :rules="[
                  {
                    required: true,
                    message: '请选择入住日期',
                    trigger: 'blur',
                  },
                ]"
                label-position="left"
                class="zhusu-fx-label"
              >
                <el-date-picker
                  v-model="fx.checkin_date"
                  class="!w-full"
                  type="date"
                  placeholder=""
                  value-format="YYYY-MM-DD"
                />
              </el-form-item>
              <el-form-item
                label="房型："
                size="default"
                :prop="'add_data.' + index + '.hotel_room_type_id'"
                label-width="auto"
                :rules="[
                  {
                    required: true,
                    message: '请选择房型',
                    trigger: 'blur',
                  },
                ]"
                label-position="left"
                class="zhusu-fx-label"
              >
                <el-select v-model="fx.hotel_room_type_id">
                  <el-option
                    v-for="item in state.hotel_room_type_data"
                    :key="item"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                  <template #footer>
                    <el-button
                      plain
                      class="float-right mb-3"
                      size="small"
                      @click="onLoadRoom"
                    >
                      刷新
                    </el-button>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item
                label="需求数量："
                :prop="'add_data.' + index + '.need_count'"
                size="default"
                :rules="[
                  {
                    required: true,
                    message: '请填写需求数量',
                    trigger: 'blur',
                  },
                ]"
                label-position="left"
                label-width="auto"
                class="zhusu-fx-label ml-5"
              >
                <el-input-number
                  v-model="fx.need_count"
                  precision="0"
                  :min="1"
                  class="!w-full"
                />
              </el-form-item>
            </ul>
            <el-form-item
              label="需求说明："
              label-position="left"
              size="default"
              class="zhusu-fx-label mt-2 !items-baseline"
            >
              <el-input
                v-model="fx.remark"
                type="textarea"
                :autosize="{ minRows: 1 }"
              />
            </el-form-item>
          </div>
          <el-button
            link
            type="danger"
            :disabled="state.model.add_data?.length <= 1"
            @click="
              () => {
                if (fx.id) {
                  state.del_ids.push(fx.id);
                }
                state.model.add_data.splice(index, 1);
              }
            "
          >
            <template #icon>
              <el-icon :size="22" class="font-bold">
                <Delete />
              </el-icon>
            </template>
          </el-button>
        </div>
        <el-button
          icon="plus"
          dashed
          style="
            color: var(--el-color-primary-light-3);
            border-color: var(--el-color-primary-light-3);
          "
          @click="onAdd"
          class="w-full"
        >
          添加
        </el-button>
      </el-form-item>
    </el-form>
    <div class="submit-box px-2.5">
      <el-button type="primary" size="large" @click="onSubmit">
        提交
      </el-button>
    </div>
  </div>
  <el-dialog
    v-model="state.showJiuDianAdd"
    title="新建酒店"
    class="c-el-dialog"
    :before-close="
      () => {
        state.showJiuDianAdd = false;
      }
    "
    append-to="#huiyi_detail"
  >
    <c_jiudian_info
      @close="
        (id) => {
          onLoadHotel();
          state.model.hotel_id = id;
          state.showJiuDianAdd = false;
        }
      "
    />
  </el-dialog>
</template>

<script>
import { computed, onMounted, reactive, ref } from "vue";
import { data_getHotel, data_getHotelRoomType } from "@/http/data";
import { dayjs } from "element-plus";
import { post_response } from "@/utils/funcs";
import {
  meeting_hotelArrange_search,
  meeting_hotelArrange_add,
  meeting_hotelArrange_edit,
} from "@/http/meeting";

import c_jiudian_info from "@/views/JiuDian/Info.vue";

export default {
  components: { c_jiudian_info },
  props: {
    meeting_id: Number,
    id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      del_ids: [],
      model: {
        add_data: [{}],
      },
    });
    onMounted(() => {
      onLoadHotel();
      if (props.id) {
        onLoadDetail();
      }
    });

    const onLoadDetail = () => {
      if (props.id) {
        meeting_hotelArrange_search(props.id).then((res) => {
          if (res.status == 200) {
            const { data } = res.data || {};

            let add_data = [];
            data.dateList.forEach((date) => {
              if (date.meetingHotelArrangeRoomTypeList?.length > 0) {
                date.meetingHotelArrangeRoomTypeList.forEach((e) => {
                  add_data.push({
                    type: "edit",
                    id: e.id,
                    meeting_id: e.meeting_id,
                    meeting_hotel_arrange_id: e.meeting_hotel_arrange_id,
                    hotel_id: e.hotel_id,
                    hotel_room_type_id: e.hotel_room_type_id,
                    checkin_date: e.checkin_date,
                    hotel_room_type_id: e.hotel_room_type_id,
                    need_count: e.need_count,
                    remark: e.remark,
                  });
                });
              }
            });

            state.model = {
              id: data.id,
              meeting_id: data.meeting_id,
              hotel_id: data.hotel_id,
              add_data: add_data,
            };
            data_getHotelRoomType(state.model.hotel_id).then((res) => {
              if (res.status == 200) {
                state.hotel_room_type_data = res.data?.data?.list || [];
              }
            });
          }
        });
      }
    };

    //获取酒店
    const onLoadHotel = () => {
      data_getHotel().then((res) => {
        if (res.status == 200) {
          state.hotel_data = res.data?.data?.list || [];
        }
      });
    };

    //酒店 id 索引，O(1) 查找
    const hotel_map = computed(() => {
      const m = new Map();
      state.hotel_data?.forEach((item) => m.set(item.id, item));
      return m;
    });

    const onLoadRoom = () => {
      state.model.add_data = state.model.add_data?.map((m) => ({
        type: m.type,
        checkin_date: m.checkin_date,
        need_count: m.need_count,
        remark: m.remark,
      }));
      if (state.model.hotel_id) {
        data_getHotelRoomType(state.model.hotel_id).then((res) => {
          if (res.status == 200) {
            state.hotel_room_type_data = res.data?.data?.list || [];
          }
        });
      }
    };

    const onAdd = () => {
      let checkin_date;
      if (state.model?.add_data?.length > 0) {
        checkin_date = dayjs(
          state.model.add_data[state.model?.add_data?.length - 1]?.checkin_date,
        )
          .add(1, "day")
          .format("YYYY-MM-DD");
      }
      state.model.add_data.push({
        type: "add",
        checkin_date,
      });
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          if (props.id) {
            const model = state.model;
            const data = {
              id: model.id,
              meeting_id: model.meeting_id,
              hotel_id: model.hotel_id,
              add_data: model.add_data.filter((w) => w.type == "add"),
              edit_data: model.add_data.filter((w) => w.type == "edit"),
              del_id: state.del_ids,
            };
            meeting_hotelArrange_edit(data).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          } else {
            state.model.meeting_id = props.meeting_id;

            meeting_hotelArrange_add(state.model).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          }
        }
      });
    };

    return {
      state,
      props,
      formDom,
      onLoadHotel,
      hotel_map,
      onLoadRoom,
      onSubmit,
      onAdd,
    };
  },
};
</script>
<style lang="scss">
.zhusu-fx-label {
  display: flex;
  align-items: center;

  .el-form-item__label-wrap {
    margin-right: 0 !important;
    width: 80px;
    justify-content: flex-end;
  }

  .el-form-item__label {
    margin-bottom: 0 !important;
  }
}
</style>
